import { PlatformName } from "@common/models";
import { docLink } from "@common/util/docs";
import { RoutePaths } from "@main/router/config/routePaths";
import { ModuleRoot } from "@main/router/util/useCurrentPathRouteConfig";

export interface ModuleInfo {
  title: string;
  description: string;
  learnMoreUrl?: string;
}

export const getModuleInfo = (platform: PlatformName | undefined) => {
  const moduleInfo: Partial<Record<ModuleRoot, ModuleInfo>> = {
    [RoutePaths.USER_FEEDBACK_MODULE_ROOT]: {
      title: "Feedback",
      description:
        "Feedback collects every bug report, suggestion, and question your users send straight from the app — along with the device, OS, screen, and everything that happened leading up to it.",
      learnMoreUrl: docLink(platform).feedback,
    },
    [RoutePaths.CRASH_MODULE_ROOT]: {
      title: "Crashes",
      description:
        "Crashes automatically captures every crash and app hang in your application, along with full context on the device, the user, and what they were doing in the minutes before it happened. ",
      learnMoreUrl: docLink(platform).crashes,
    },
    [RoutePaths.USERS_MODULE_ROOT]: {
      title: "Users",
      description:
        "Users shows every person using your app, with their info, ticket history, and a live chat — so you instantly see who's affected by a bug or crash and can reach out to them directly.",
      learnMoreUrl: docLink(platform).users,
    },
    [RoutePaths.RELEASES_MODULE_ROOT]: {
      title: "Releases",
      description:
        "Releases scores every release you ship from 0 to 10, so you instantly know if it's safe to ship. The score is built from crash-free sessions, coverage, endpoints health, resolution rate, and more — all in one place.",
      learnMoreUrl: docLink(platform).releases,
    },
  };
  return moduleInfo;
};
